<template>
  <div>
    <el-dialog custom-class="dialogClass"
               :visible.sync="centerDialogVisible"
               width="50%"
               @close="$emit('close')"
               center>
      <div>
        <video controls
               class="video"
               :autoplay="false"
               :src="data.resourceUrl || data.contentText"></video>
        <!-- 试看视频操作菜单 -->
        <div class="content flexStart"
             v-if="isContent">
          <div>{{data.courseName}} | </div>
          <div class="font20 mainColor"
               style="margin-right:20px">￥{{data.price}}</div>

          <el-button class="mainBgColor"
                     style="color:#fff"
                     v-if="data.onlineCourseType == '2'"
                     type="danger"
                     @click="link(1)">会员免费学</el-button>
          <el-button class="mainBgColor"
                     style="color:#fff"
                     v-if="data.onlineCourseType == '1' && data.ifVipFree == '1'"
                     type="danger"
                     @click="link(3)">个人会员免费学</el-button>
          <el-button class="mainBgColor"
                     style="color:#fff"
                     v-if="data.onlineCourseType == '1' && data.ifVipFree == '1'"
                     type="danger"
                     @click="link(4)">企业会员免费学</el-button>
          <el-button type="danger"
                     @click="link(2)">下载APP单独购买</el-button>

        </div>
      </div>

    </el-dialog>
  </div>

</template>
<script>
export default {
  data () {
    return {
      centerDialogVisible: false,
      videoUrl: '',
      data: {},
      isContent: false
    }
  },
  methods: {
    init (data, type) {
      this.centerDialogVisible = true;
      this.data = data
      if (type && type == 'content') {
        this.isContent = true
      }
    },
    link (type) {
      if (type == 1) {
        this.$router.push('/Card?type=cur&index=1')
      } else if (type == 3) {
        this.$router.push('/Card?type=cur&index=2')
      } else if (type == 4) {
        this.$router.push('/Card?type=cur')
      } else {
        this.$router.push('/download')
      }
    },
  }
}
</script>
<style lang="less" scoped>
.dialogClass {
  padding: 0 !important;
}
.video {
  width: 100%;
  height: 100%;
}
.content {
  padding: 10px 0 0 0;
  box-sizing: border-box;
}
</style>